import { render, staticRenderFns } from "./order-return-form.component.vue?vue&type=template&id=0cc3b0dc&"
import script from "./order-return-form.component.vue?vue&type=script&lang=ts&"
export * from "./order-return-form.component.vue?vue&type=script&lang=ts&"
import style0 from "./order-return-form.component.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "order-return-form.component.vue"
export default component.exports